import * as Types from '../graphqlBase.generated';

import { TypedDocumentString } from "~/gql/graphqlBase.generated";
import { baseApiWithGraphql } from '~/services/baseApi';
import type { GraphqlEndpointBuilder } from '~/services/baseApi';
export type GetJobEventsInSelectionQueryVariables = Types.Exact<{
  selection: Types.JobEventsSelectionInput;
}>;


export type GetJobEventsInSelectionQuery = { __typename?: 'Query', jobEventsInSelection: { __typename?: 'JobEventSelectionPayload', jobCount: number, events: Array<{ __typename?: 'JobEventSelectionEvent', kind: Types.JobEventKind, eventId: string, jobCount: number }> } };


export const GetJobEventsInSelectionDocument = new TypedDocumentString(`
    query GetJobEventsInSelection($selection: JobEventsSelectionInput!) {
  jobEventsInSelection(selection: $selection) {
    jobCount
    events {
      kind
      eventId
      jobCount
    }
  }
}
    `);
const injectedRtkApiEndpoints = (build: GraphqlEndpointBuilder) => ({
    GetJobEventsInSelection: build.query<GetJobEventsInSelectionQuery, GetJobEventsInSelectionQueryVariables>({
      query: (variables) => ({ document: GetJobEventsInSelectionDocument, variables })
    }),
});

const injectedRtkApi = baseApiWithGraphql.injectEndpoints({ endpoints: injectedRtkApiEndpoints });

export type GeneratedEndpointDefinitions = ReturnType<typeof injectedRtkApiEndpoints>;

export { injectedRtkApi as api };
export const { useGetJobEventsInSelectionQuery, useLazyGetJobEventsInSelectionQuery } = injectedRtkApi;
